import { useTranslation } from '@crehana/i18n';

import type { CrehanaLiveLocaleKeys } from '../types';

const useCrehanaLiveTranslations = () =>
  useTranslation<CrehanaLiveLocaleKeys>();

export default useCrehanaLiveTranslations;
